import { useState, useMemo } from 'react'
import { PairingType, DarknessLevel } from '../data/romanceTaggingData'
import { computeRomanceClassification } from '../utils/romanceTaggingEngine'

export function useRomanceTagging() {
  const [selectedPairingType, setSelectedPairingType] =
    useState<PairingType | null>(null)
  const [selectedTropes, setSelectedTropes] = useState<string[]>([])
  const [selectedCharacterPairings, setSelectedCharacterPairings] = useState<
    string[]
  >([])
  const [selectedContentWarnings, setSelectedContentWarnings] = useState<
    string[]
  >([])
  const [darknessLevel, setDarknessLevel] = useState<DarknessLevel | null>(null)
  const [warningsConfirmed, setWarningsConfirmed] = useState(false)

  const classification = useMemo(() => {
    return computeRomanceClassification({
      pairingType: selectedPairingType,
      tropes: selectedTropes,
      characterPairings: selectedCharacterPairings,
      contentWarnings: selectedContentWarnings,
      darknessLevel,
    })
  }, [
    selectedPairingType,
    selectedTropes,
    selectedCharacterPairings,
    selectedContentWarnings,
    darknessLevel,
  ])

  const showDarknessPrompt = classification.darkness_required && !darknessLevel

  return {
    selectedPairingType,
    setSelectedPairingType,
    selectedTropes,
    setSelectedTropes,
    selectedCharacterPairings,
    setSelectedCharacterPairings,
    selectedContentWarnings,
    setSelectedContentWarnings,
    darknessLevel,
    setDarknessLevel,
    warningsConfirmed,
    setWarningsConfirmed,
    classification,
    showDarknessPrompt,
  }
}
